<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
.first-item-zero-margin:first-of-type {
  margin-top: -10px !important;
}

.v-select__selections {
  max-height: 40px;
  overflow: auto;
  min-height: 40px !important;
  height: 30px;
}

.v-select__selections .v-chip--select {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.v-select__selections .v-chip {
  height: 25px !important;
}
</style>
